import _objectSpread from "/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import util from '@/libs/util';
import { fetchRoleMenus } from '@api/u8.api.menu';
export default {
  computed: _objectSpread(_objectSpread({}, mapState('u8sdk/menu', {
    collapse: function collapse(state) {
      return state.collapse;
    },
    sidebar: function sidebar(state) {
      return state.sidebar;
    }
  })), mapState('u8sdk/theme', {
    activeName: function activeName(state) {
      return state.activeName;
    }
  })),
  data: function data() {
    return {
      currLogoSrc: '',
      currLogoCollapsedSrc: '',
      currActive: '',
      menus: []
    };
  },
  mounted: function mounted() {// this.currActive = this.$route.path
  },
  watch: {
    '$route.matched': {
      handler: function handler(val) {
        var currRoute = val[val.length - 1];
        this.currActive = currRoute.path.substring(1);
      },
      immediate: true
    }
  },
  methods: {
    backToHome: function backToHome() {
      // 菜单path中是不带/这个的，需要加上
      this.$router.push({
        path: '/'
      });
    },
    handleMenuSelect: function handleMenuSelect(index, indexPath) {
      if (/^https:\/\/|http:\/\//.test(index)) {
        util.open(index);
      } else {
        // 菜单path中是不带/这个的，需要加上
        this.$router.push({
          path: '/' + index
        });
      }
    }
  }
};